export default "__VITE_ASSET__ZMSu0fWB__"